/**
 * @generated SignedSource<<f4ed4b13893122fa37e579df4ce2d1c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageItemActions_package$data = {
  readonly __typename: string;
  readonly id: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_package">;
  readonly " $fragmentType": "PackageItemActions_package";
};
export type PackageItemActions_package$key = {
  readonly " $data"?: PackageItemActions_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageItemActions_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageItemActions_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageModal_package"
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "b376d7e49058c0df1b2f4680cb73cf73";

export default node;
